import { currenciesSlice } from "./currenciesSlice";
import * as actions from "./currenciesActions";
import * as selectors from "./currenciesSelectors";

export { actions };
export { selectors };
export default currenciesSlice.reducer;
